import type { TRuleWithTheme } from '@/styles/theme';

export const content: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '2rem',

    width: '100%',
});

export const body: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '1.5rem',

    width: '100%',
});

export const group: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '1rem',

    width: '100%',
});

export const paragraph: TRuleWithTheme = () => ({
    fontWeight: 500,
    letterSpacing: 0,
});

export const submitButton: TRuleWithTheme = () => ({
    '&.ant-btn': {
        height: '2.5rem',

        fontWeight: 500,
        letterSpacing: 0,
    },
    // antd v6 sets round-button radius through `.ant-btn.ant-btn-round.ant-btn` — repeating
    // `.ant-btn` here matches that trick and out-specifies it. Padding needs `!important`: both
    // antd and Button.rules.ts declare it on selectors carrying more classes than this scoped
    // override can reach (antd adds `:not(.ant-btn-icon-only)`, Button.rules.ts three `:not`s).
    '&.ant-btn.ant-btn-round.ant-btn': {
        borderRadius: '1.25rem',

        paddingLeft: '1.25rem !important',
        paddingRight: '1.25rem !important',
    },
});
